module.exports = __webpack_public_path__ + "img/productIcon6.e007351a.png";